import React from 'react';

import cx from 'classnames';
import OutsideClickHandler from 'react-outside-click-handler';

import datePickerStyles from 'components/Pages/Admin/Itinerary/Details/shared/DatePickerButton/index.module.css';
import DefaultInput from 'components/shared/FormAdapters/FormDefault/Input';
import Icon from 'components/shared/Icon';
import Close from 'components/shared/Icon/icons/Close';

import s from './index.module.css';
import { useTimePicker } from './useTimePicker';

const TimePicker = (props) => {
  const { onChange, ...rest } = props;
  const {
    setShowPicker,
    showPicker,
    pickerValue,
    hoursCollection,
    minutesCollection,
    AMPMoptionsCollection,
    handleItemClick,
    handleClear,
  } = useTimePicker(props);

  const timepickerWrapperClasses = cx(
    datePickerStyles.popupContainer,
    s.timepickerWrapper,
    showPicker && s.timepickerWrapperActive,
  );

  return (
    <OutsideClickHandler onOutsideClick={() => setShowPicker(false)}>
      <div className={s.container}>
        <DefaultInput
          {...rest}
          onChange={onChange}
          onFocus={() => setShowPicker(true)}
          readOnly
          postfix={props.value && <Icon component={Close} className={s.iconClear} onClick={handleClear} />}
          postfixClassName={s.postfix}
          className={s.input}
        />

        <div className={timepickerWrapperClasses}>
          <div className={s.items} id="hoursWrap">
            {hoursCollection.map((item) => (
              <div
                key={item}
                data-name="hours"
                data-value={item}
                data-hours-active={pickerValue?.hours === item}
                onClick={handleItemClick}
                className={cx(s.item, pickerValue?.hours === item && s.itemActive)}
              >
                {item}
              </div>
            ))}
          </div>
          <div className={s.items} id="minutesWrap">
            {minutesCollection.map((item) => (
              <div
                key={item}
                data-name="minutes"
                data-value={item}
                data-minutes-active={pickerValue?.minutes === item}
                onClick={handleItemClick}
                className={cx(s.item, pickerValue?.minutes === item && s.itemActive)}
              >
                {item}
              </div>
            ))}
          </div>
          <div className={s.items}>
            {AMPMoptionsCollection.map((item) => (
              <div
                key={item}
                data-name="ampm"
                data-value={item}
                onClick={handleItemClick}
                className={cx(s.item, pickerValue?.ampm === item && s.itemActive)}
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export default TimePicker;
